import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../Routes/Routes";

export default function FooterSection() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <footer className="tw-w-full tw-py-2 tw-px-4 tw-bg-[#F7F9FB] tw-text-center" dir="rtl">
      <div className="tw-max-w-5xl tw-mx-auto tw-text-[#222831]">
        <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-2 tw-mb-1">
          {!isHomePage && (
            <>
              <Link
                to={`/${ROUTES.AGENT_TERMS}`}
                className="tw-text-xs tw-text-[#0456A0] hover:tw-text-[#033d73] tw-underline tw-transition-colors"
                target="_blank"
              >
                תקנון סוכנים
              </Link>
              <span className="tw-text-xs tw-text-gray-400">|</span>
            </>
          )}
          <Link
            to={`/${ROUTES.TERMS_AND_CONDITIONS}`}
            className="tw-text-xs tw-text-[#0456A0] hover:tw-text-[#033d73] tw-underline tw-transition-colors"
            target="_blank"
          >
            תקנון הזמנה
          </Link>
        </div>
        <div className="tw-text-xs tw-opacity-80">
          © {new Date().getFullYear()} כל הזכויות שמורות.
        </div>
      </div>
    </footer>
  );
}


